import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useAddShiftMutation, useUpdateShiftMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";

const ManageShift = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
}) => {

    const [addShiftApi, { isLoading }] = useAddShiftMutation()
    const [updateShiftApi, { isLoading: updateIsLoading }] = useUpdateShiftMutation()

    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        shiftName: Yup.string()
            .required("Shift Name is required")
            .matches(
                /^[A-Za-z\s]+$/,
                "Shift Name can contain only alphabets"
            )
            .trim(),
        shiftStart: Yup.string()
            .required("Shift Start time is required")
            .trim(),
        shiftEnd: Yup.string()
            .required("Shift End time is required")
            .trim(),
    });

    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all',
    });

    useEffect(() => {
        console.log(data,'data')
        if (data) {
            reset({
                shiftName: data.shift_name,
                shiftStart: data.shift_start,
                shiftEnd: data.shift_end,
            });
        }
    }, [])

    const resetButton = () => {
        reset({
            shiftName: "",
            shiftStart: "",
            shiftEnd: "",
        });
    };

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const data = {
                    shift_name: payload.shiftName,
                    shift_start: payload.shiftStart,
                    shift_end: payload.shiftEnd,
                }

                console.log(payload, "data", data)

                const response = await addShiftApi(data)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }

            } else {

                const updateData = {
                    shift_name: payload.shiftName,
                    shift_start: payload.shiftStart,
                    shift_end: payload.shiftEnd,
                    id: data.id,
                }
                const response = await updateShiftApi(updateData)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Add Shift" : "Manage Shift"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a New Shift." : "Update the details below to Manage Shift"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Shift Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="shiftName"
                                        name='shiftName'
                                        placeholder='Enter the Shift name'
                                        {...register('shiftName')}
                                        className="form-control"

                                    />
                                    {errors.shiftName && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.shiftName.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Shift Start <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="time"
                                        id="shiftStart"
                                        {...register("shiftStart")}
                                        className="shift-time-input"
                                    />
                                    {errors.shiftStart && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.shiftStart.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Shift End <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="time"
                                        id="shiftEnd"
                                        {...register("shiftEnd")}
                                        className="shift-time-input"

                                    />
                                    {errors.shiftEnd && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.shiftEnd.message}
                                        </p>
                                    )}
                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Add Shift" : "Update Shift"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>
                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default ManageShift;